module.exports = __webpack_public_path__ + "static/media/Arial-Narrow.a4802f27.ttf";